import React, { useState, useEffect } from 'react';
import axios from 'axios';
import LoadingLogo from './LoadingLogo';
import Seo from './Seo';

// Clean ProductListt component: defines fetchTestimonials and keeps handlers in-scope
const ProductListt = () => {
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [blogPosts, setBlogPosts] = useState([]);
  const [lastResponse, setLastResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchTestimonials();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function fetchTestimonials() {
    try {
      const res = await axios.get('http://apifusion.synergyindustri.com/api/acordio-getall/');
      setLastResponse(res.data);

      // Accept multiple common response shapes from different APIs
      const items = Array.isArray(res.data)
        ? res.data
        : (res.data && (res.data.results || res.data.data || res.data.items))
        ? (res.data.results || res.data.data || res.data.items)
        : [];

      console.log('ProductListt: fetched items count=', items.length, 'sample=', items[0]);
      setBlogPosts(items);
    } catch (err) {
      console.error('Error fetching testimonials:', err);
    } finally {
      setIsLoading(false);
    }
  }

  const handleChangePicture = (postId) => {
    const onFile = (e) => {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = async (ev) => {
        const base64 = ev.target.result;
        const title = prompt('Enter the new title:');
        const description = prompt('Enter the new description:');
        if (!title || !description) return;
        try {
          const token = localStorage.getItem('token');
          await axios.put(`http://apifusion.synergyindustri.com/api/acordio/${postId}/`, { image: base64, title, description }, { headers: { Authorization: `token ${token}` } });
          fetchTestimonials();
        } catch (err) {
          console.error(err);
        }
      };
      reader.readAsDataURL(file);
    };
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.addEventListener('change', onFile);
    input.click();
  };

  const handleAddImage = () => {
    const onFile = (e) => {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      const title = prompt('Enter the title:');
      const description = prompt('Enter the description:');
      if (!title || !description) return;
      const reader = new FileReader();
      reader.onload = async (ev) => {
        const base64 = ev.target.result;
        const formData = new FormData();
        formData.append('image', base64);
        formData.append('title', title);
        formData.append('description', description);
        try {
          const token = localStorage.getItem('token');
          await axios.post('http://apifusion.synergyindustri.com/api/acordio/create/', formData, { headers: { Authorization: `token ${token}`, 'Content-Type': 'multipart/form-data' } });
          fetchTestimonials();
        } catch (err) {
          console.error(err);
        }
      };
      reader.readAsDataURL(file);
    };
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.addEventListener('change', onFile);
    input.click();
  };

  const handleDelete = async (postId) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`http://apifusion.synergyindustri.com/api/acordio/${postId}/delete/`, { headers: { Authorization: `token ${token}` } });
      fetchTestimonials();
    } catch (err) {
      console.error(err);
    }
  };

  const products = [
    { id: 1, name: 'Product 1', description: 'Sample product description.' },
    { id: 2, name: 'Product 2', description: 'Sample product description.' },
    { id: 3, name: 'Product 3', description: 'Sample product description.' },
  ];

  const isLoggedIn = !!(localStorage.getItem('token') && localStorage.getItem('user'));

  const SupplierCard = ({ id, image, name, description }) => (
    <div className="bg-white shadow-md rounded-lg overflow-hidden hover:shadow-lg">
      <img className="w-full h-32 object-cover" src={image} alt={name} />
      <div className="p-2">
        <h3 className="text-lg font-medium mb-2">{name}</h3>
        <p className="text-gray-600 text-sm">{description}</p>
      </div>
      {isLoggedIn && (
        <div className="p-2 flex flex-row justify-end gap-2">
          <button className="text-white hover:bg-blue-800 mr-2 bg-blue-600 rounded-lg px-4 py-1" onClick={() => handleChangePicture(id)}>Edit</button>
          <button className="text-white hover:bg-red-800 mr-2 bg-red-600 rounded-lg px-4 py-1" onClick={() => handleDelete(id)}>Delete</button>
        </div>
      )}
    </div>
  );

  return (
    <div>
      <Seo
        title="Industrial Automation & SCADA Products — Fusion Tech Dubai"
        description="Fusion Tech supplies Industrial Automation, SCADA, PLC/RTU/DCS, control panels, and spare parts in Dubai, UAE. Browse our supplier cards and product list for automation spare parts and machine supply."
        url="http://fusiontechuae.com/productlist"
        image="http://fusiontechuae.com/fusion-social.png"
        keywords={`Industrial Automation Dubai UAE, SCADA Solutions in Dubai, Telemetry Solutions in Dubai UAE, Electrical Spare Parts in Dubai UAE, Automation Spare Parts Dubai UAE, PLC, RTU, DCS from Dubai, Control Panels from Dubai, Machine Supply from Dubai`}
        jsonLd={
          blogPosts && blogPosts.length
            ? {
                '@context': 'https://schema.org',
                '@type': 'ItemList',
                itemListElement: blogPosts.slice(0, 50).map((p, i) => ({
                  '@type': 'ListItem',
                  position: i + 1,
                  name: p.title || p.name || `Item ${p.id}`,
                  url: `http://fusiontechuae.com/productlist#${p.id}`
                }))
              }
            : undefined
        }
      />
      <div className="container mx-auto">
      <h1 className="text-xl font-bold my-4">Industrial Automation & SCADA Products — Dubai, UAE</h1>
      <p className="text-gray-600 mb-4">Fusion Tech supplies PLCs, RTUs, DCS, control panels, automation spare parts and complete machine supply for industrial customers in Dubai and the UAE. Search: SCADA Solutions in Dubai, Telemetry Solutions in Dubai UAE, Industrial Automation Dubai UAE.</p>
      {isLoading ? (
        <LoadingLogo />
      ) : (
        <>
          {products.map((product) => (
            <div key={product.id} className="border rounded-lg p-2 mb-2 hover:bg-blue-400">
              <div className="flex items-center justify-between cursor-pointer" onClick={() => setActiveAccordion(product.id === activeAccordion ? null : product.id)}>
                <h3 className="text-sm font-semibold">{product.name}</h3>
                <svg xmlns="http://www.w3.org/2000/svg" className={`h-4 w-4 transform ${activeAccordion === product.id ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </div>
              {activeAccordion === product.id && (<div className="mt-2"><p className="text-sm">{product.description}</p></div>)}
            </div>
          ))}

          <div className="border rounded-lg p-2 mt-4">
            <h2 className="text-xl font-bold mb-2">Our Brand and Insights</h2>
            <p className="text-sm">Short description about brand.</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 mt-4">
            {blogPosts.length > 0 ? (
              blogPosts.map((post) => (
                <SupplierCard key={post.id} id={post.id} image={post.image} name={post.title || post.name} description={post.description || post.summary || post.body} />
              ))
            ) : (
              <div className="col-span-full p-4 text-center text-sm text-gray-600">
                No products were returned from the API.
                {lastResponse ? (
                  <div className="mt-3 text-left overflow-auto max-h-48 bg-white p-2 border rounded text-xs">
                    <pre>{JSON.stringify(lastResponse, null, 2)}</pre>
                  </div>
                ) : null}
              </div>
            )}
          </div>

          {isLoggedIn && (
            <div className="flex justify-center items-center mt-4">
              <button className="text-white hover:bg-green-800 bg-green-600 rounded-lg px-4 py-2" onClick={handleAddImage}>Add Post</button>
            </div>
          )}
        </>
      )}
      </div>
    </div>
  );
};

export default ProductListt;

